export default __webpack_public_path__ + "static/media/Emojis03.53600518.png";